import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';
import { AuthLayout } from 'src/layouts/auth';

import { SplashScreen } from 'src/components/loading-screen';
import { PATHS } from 'src/routes/paths';
import { AuthCompactLayout } from 'src/layouts/auth/auth-compact-layout';

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import('src/pages/auth/login'));
const RegisterPage = lazy(() => import('src/pages/auth/register'));
const ForgotPasswordPage = lazy(() => import('src/pages/auth/forgot-password'));
const NewPasswordPage = lazy(() => import('src/pages/auth/new-password'));
const ConfirmPage = lazy(() => import('src/pages/auth/confirm'));

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        element: (
          <GuestGuard>
            <AuthLayout>
              <LoginPage />
            </AuthLayout>
          </GuestGuard>
        ),
        path: PATHS.auth.login,
      },
      {
        element: (
          <GuestGuard>
            <AuthLayout>
              <RegisterPage />
            </AuthLayout>
          </GuestGuard>
        ),
        path: PATHS.auth.register,
      },
      {
        element: (
          <GuestGuard>
            <AuthCompactLayout>
              <ForgotPasswordPage />
            </AuthCompactLayout>
          </GuestGuard>
        ),
        path: PATHS.auth.forgotPassword,
      },
      {
        element: (
          <GuestGuard>
            <AuthCompactLayout>
              <NewPasswordPage />
            </AuthCompactLayout>
          </GuestGuard>
        ),
        path: PATHS.auth.newPassword,
      },
      {
        element: (
          <GuestGuard>
            <AuthCompactLayout>
              <ConfirmPage />
            </AuthCompactLayout>
          </GuestGuard>
        ),
        path: PATHS.auth.confirmEmail,
      },
    ],
  },
];
